import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app',
  template: `<atlaz-bnp></atlaz-bnp>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {}
